import { useEffect, useState } from "react";
import { BoxBase, CheckboxBase, FormControlBase, FormSectionBox, FormSectionTitle, InputLabelSelect, SelectBase, TextFieldBase } from "../../styles";
import { Box, Collapse, Container, FormControlLabel, FormGroup, Grid, IconButton, MenuItem, Switch } from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";

import api from "../../../../Api/apiAxios";

export function LicencaSection({ licenca, dataPedido, isPonto = false }) {
	const [isExpanded, setIsExpanded] = useState(true);
  const [modalidadeComercializacao, setModalidadeComercializacao] = useState(0);
  const [modalidadeServico, setModalidadeServico] = useState(0);
  const [plano, setPlano] = useState(0);
  const [tipoLicenciamento, setTipoLicenciamento] = useState(0);
	const [dataCancelamentoContrato, setDataCancelamentoContrato] = useState(null);
	const [usuariosAdicionais, setUsuariosAdicionais] = useState([]);
	const [checkboxLicenciado, setCheckboxLicenciado] = useState(false);

	const nivelUsuario = window.localStorage.getItem('nivelUsuario');

  useEffect(() => {
		async function loadData() {
			loadModalidades();
			await loadContratoAnterior();
			await loadPedidoAnterior();
		}
    
		loadData();
  }, []);

	const loadContratoAnterior = async () => {
		try {
			const { data } = await api.get(`/Contrato/retornar-situacao-contrato?numeroSerie=${licenca.numeroSerie}`);

			if (data.dataCancelamento) setDataCancelamentoContrato(data.dataCancelamento);
		} catch (error) {
			console.log('Erro ao carregar ultimo valor do contrato' + error);
		}
	}

	const loadPedidoAnterior = async () => {
		try {
			const { data } = await api.get(`/BmaPonto/${licenca.pedidoId}`); 

			setUsuariosAdicionais(data.usuariosAdicionais);
			setCheckboxLicenciado(data.licenciado);
		} catch (error) {
			console.log('Erro ao carregar ultimo valor do contrato' + error);
		}
	}

  const loadModalidades = () => {
    if (licenca?.tipoComercializacao !== null && licenca?.tipoComercializacao !== undefined) {
      setFieldsFromTipoComercializacao(licenca);
    } else {
      const config = getModalidadeConfig(licenca.tipoInstalacao);
      setFieldsFromConfig(config);
    }
  };

  const setFieldsFromTipoComercializacao = (fields) => {
    setModalidadeComercializacao(fields.tipoComercializacao);
    setModalidadeServico(fields.tipoServicoPedido);
    setPlano(fields.tipoPlano);
    setTipoLicenciamento(fields.tipoLicenciamento);
  };

  const getModalidadeConfig = (tipoInstalacao) => {
    const config = {
			[null]: {
        modalidadeComercializacao: 1,
        modalidadeServico: 1,
        plano: 1,
        tipoLicenciamento: 2,
        tipoPlano: tipoInstalacao,
      },
      0: {
        modalidadeComercializacao: 1,
        modalidadeServico: 1,
        plano: 1,
        tipoLicenciamento: 2,
        tipoPlano: tipoInstalacao,
      },
      1: {
        modalidadeComercializacao: 2,
        modalidadeServico: 2,
        plano: 1,
        tipoPlano: tipoInstalacao,
      },
      2: {
        modalidadeComercializacao: 2,
        modalidadeServico: 2,
        plano: 2,
        tipoPlano: tipoInstalacao,
      },
    };

    return config[tipoInstalacao];
  };

  const setFieldsFromConfig = (config) => {
    setModalidadeComercializacao(config.modalidadeComercializacao);
    setModalidadeServico(config.modalidadeServico);
    setPlano(config.plano);
    setTipoLicenciamento(config.tipoLicenciamento);
  };

  return (
    <FormSectionBox>
      <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "start", width: '100%' }}>
        <FormSectionTitle label="Dados da Licença Anterior" />
        <IconButton 
					onClick={() => setIsExpanded((prev) => !prev)} 
					size="small" 
					sx={{ mt: -6, ":hover": { backgroundColor: 'transparent', opacity: 0.8 } }}
				>
          {isExpanded ? <RemoveIcon /> : <AddIcon />}
        </IconButton>
      </Box>

			<Collapse in={isExpanded} timeout="auto" unmountOnExit sx={{ width: '100%' }}>
				<Container sx={{ display: "flex", flexDirection: "column", my: 3 }}>
					<BoxBase justifyContent={"flex-start"}>
						<FormControlBase>
							<InputLabelSelect>Modalidade de Comercialização</InputLabelSelect>
							<SelectBase
								label="Modalidade de Comercialização"
								value={licenca?.tipoComercializacao ?? modalidadeComercializacao ?? ""}
								onChange={(e) => setModalidadeComercializacao(e.target.value)}
								width="32rem"
								isShow
							>
								<MenuItem value={1}>Licenciado</MenuItem>
								<MenuItem value={2}>Locação</MenuItem>
							</SelectBase>
						</FormControlBase>

						{(licenca?.tipoComercializacao === 1 || modalidadeComercializacao === 1) && 
							<FormGroup>
								<FormControlLabel 
									control={
										<Switch 
											size="small" 
											checked={licenca.tipoLicenciamento === 1 || tipoLicenciamento === 1} 
										/>
									} 
									label="Anual" 
								/>
							</FormGroup>
						}
					</BoxBase>

					<BoxBase>
						<FormControlBase>
							<InputLabelSelect>Modalidade de Serviço</InputLabelSelect>
							<SelectBase
								label="Modalidade de Serviço"
								value={licenca?.tipoServicoPedido ?? modalidadeServico ?? ""}
								onChange={(e) => setModalidadeServico(e.target.value)}
								width="32rem"
								isShow
							>
								<MenuItem value={1}>On Premisse</MenuItem>
								<MenuItem value={2}>SaaS</MenuItem>
							</SelectBase>
						</FormControlBase>

						{isPonto &&
							<FormControlBase margin="0 0 0 -2rem">
								<InputLabelSelect>Plano</InputLabelSelect>
								<SelectBase
									label="Plano"
									value={licenca?.tipoPlano ?? plano ?? ""}
									onChange={(e) => setPlano(e.target.value)}
									width="30.5rem"
									isShow
								>
									<MenuItem value={1}>Rep C</MenuItem>
									<MenuItem value={2}>Rep P</MenuItem>
								</SelectBase>
							</FormControlBase>
						}
					</BoxBase>

					<BoxBase>
						<FormControlBase>
							<InputLabelSelect>Banco de Dados</InputLabelSelect>
							<SelectBase 
								label="Banco de Dados"
								value={licenca.tipoBancoDados}
								isShow
								width='20rem'
							>
								<MenuItem value={1}>MySql</MenuItem>
								<MenuItem value={2}>SqlServer</MenuItem>
								<MenuItem value={3}>Oracle</MenuItem>
							</SelectBase>
						</FormControlBase>

						<FormControlBase>
							<TextFieldBase
								label="Versão"
								value={licenca.versao}
								disabled
								width='20rem'
							/>
						</FormControlBase>

						<FormControlBase>
							<TextFieldBase 
								label="Início do Faturamento" 
								type="date"
								value={licenca?.dataInicioFaturamento}
								width='20rem'
								disabled
							/>
						</FormControlBase>
					</BoxBase>

					<BoxBase>
						<FormControlBase>
							<TextFieldBase 
								label="Data de Validade" 
								type="date"
								value={licenca.dataValidade ? licenca.dataValidade : null}
								width='20rem'
								disabled
							/>
						</FormControlBase>

						<FormControlBase>
							<TextFieldBase 
								label="Data de Registro" 
								type="date"
								value={licenca?.dataRegistro}
								width='20rem'
								disabled
							/>
						</FormControlBase>

						<FormControlBase>
							<TextFieldBase 
								label="Data do Pedido" 
								type="date"
								value={dataPedido ? dataPedido : null}
								width='20rem'
								disabled
							/>
						</FormControlBase>
					</BoxBase>

					<BoxBase>
						<FormControlBase>
							<TextFieldBase 
								label="Data de Liberação" 
								type="date"
								value={licenca.dataLiberacao ? licenca.dataLiberacao : null}
								width='20rem'
								disabled
							/>
						</FormControlBase>

						<FormControlBase>
							<TextFieldBase 
								label="Contrato Cancelado em" 
								type="date"
								value={dataCancelamentoContrato}
								width='20rem'
								disabled
							/>
						</FormControlBase>

            {!isPonto &&
							<FormControlBase>
								<TextFieldBase
									label="Usuários Adicionais"
									value={usuariosAdicionais}
									disabled
									width='20rem'
								/>
							</FormControlBase>
						}

            {isPonto && 
            <FormControlBase>
              <TextFieldBase
                label="Total de Usuários"
                value={licenca.quantidadeUsuarios}
                disabled
                width='20rem'
              />
            </FormControlBase>
						}
						
					</BoxBase>

					{isPonto && 
						<BoxBase>
              <FormControlBase>
								<TextFieldBase
									label="Token"
									value={licenca.token}
									disabled
									width='20rem'
								/>
							</FormControlBase>

							<FormControlBase>
								<TextFieldBase
									label="Faixa de Funcionários"
									value={licenca.faixaFuncionarios}
									disabled
									width='20rem'
								/>
							</FormControlBase>

							<FormControlBase>
								<TextFieldBase
									label="Usuários Adicionais"
									value={usuariosAdicionais}
									disabled
									width='20rem'
								/>
							</FormControlBase>
						</BoxBase>
					}

					<BoxBase justifyContent={"flex-start"}>
						{isPonto ? (
							<>
								<Grid container spacing={2} sx={{ pb: 2, pl: 4, mt: 1, display: 'flex' }}>
									<Grid item xs={3}>
										<CheckboxBase
											checked={licenca.portaria671 === 1}
											disabled
											label="Portaria 671"
										/>                        
									</Grid>
									<Grid item xs={3}>
										<CheckboxBase
											checked={licenca.integradorRep === 1}
											disabled
											label="Integrador REP"
										/>  
									</Grid>
									<Grid item xs={3}>
										<CheckboxBase
											checked={licenca.moduloEPI === 1}
											disabled
											label="Módulo EPI"
										/> 
									</Grid>
									<Grid item xs={3}>
										<CheckboxBase
											checked={licenca.integracaoAcesso === 1}
											disabled
											label="Acesso"
										/> 
									</Grid>
									<Grid item xs={3}>
										<CheckboxBase
											name="Folha"
											checked={licenca.integracaoFolha === 1}
											disabled
											label="Folha"
										/> 
									</Grid>
									<Grid item xs={3}>
										<CheckboxBase
											name="contrato"
											checked={licenca.temContrato === 1}
											disabled
											label="Contrato"
										/> 
									</Grid>
                  {isPonto && 
                  <>
                      <Grid item xs={3}>
                        <CheckboxBase
                          name="moduloAvaliacao"
                          checked={licenca.moduloAvaliacao === 1}
                          disabled
                          label="Módulo Avaliações"
                        />
                      </Grid>
                      <Grid item xs={3}>
                        <CheckboxBase
                          name="moduloDocumentos"
                          checked={licenca.moduloDocumentos === 1}
                          disabled
                          label="Gestão de Documentos"
                        />
                      </Grid>
                  </>
                  }
									{nivelUsuario === '1' && 
										<Grid item xs={3}>
											<CheckboxBase
												checked={checkboxLicenciado === 1}
												disabled
												label="Licenciado"
											/>
										</Grid>
									}
								</Grid>
							</>
						) : (
							<>
								<Grid container spacing={2} sx={{ pb: 2, pl: 4, mt: 1, display: 'flex' }}>
									<Grid item xs={3}>
										<CheckboxBase
											checked={licenca.temContrato === 1}
											disabled
											label="Contrato"
										/> 
									</Grid>

									<Grid item xs={3}>
										<CheckboxBase
											checked={licenca.moduloLGPD === 1}
											disabled
											label="Módulo LGPD"
										/> 
									</Grid>

									<Grid item xs={3}>
										<CheckboxBase
											checked={licenca.portalTerceiros === 1}
											disabled
											label="Portal Terceiros"
										/> 
									</Grid>

									<Grid item xs={3}>
										<CheckboxBase
											checked={licenca.integracaoAlunos === 1}
											disabled
											label="Alunos"
										/> 
									</Grid>

									<Grid item xs={3}>
										<CheckboxBase
											checked={licenca.integracaoFuncionarios === 1}
											disabled
											label="Funcionários"
										/>  
									</Grid>
									<Grid item xs={3}>
										<CheckboxBase
											checked={licenca.integracaoPacientes === 1}
											disabled
											label="Pacientes"
										/> 
									</Grid>

									<Grid item xs={3}>
										<CheckboxBase
											checked={licenca.wpe === 1}
											disabled
											label="Ponto"
										/>                        
									</Grid>
									
									<Grid item xs={3}>
										<CheckboxBase
											checked={licenca.agendaWeb === 1}
											disabled
											label="Portal Acesso"
										/> 
									</Grid>

									<Grid item xs={3}>
										<CheckboxBase
											checked={licenca.pontoSaas === 1}
											disabled
											label="BMA Ponto SaaS via API"
										/> 
									</Grid>
								</Grid>
							</>
						)}
					</BoxBase>
				</Container>
			</Collapse>
    </FormSectionBox>
  );
}
